const observerOptions = {
    threshold: [0, 0.25, 0.5, 0.75, 1],
};
const getObserver = function (rootEl, observerCb) {
    const observerCallback = function (entries) {
        entries.forEach((entry) => {
            observerCb(entry);
        });
    };
    if (typeof window !== 'undefined' && window.IntersectionObserver && rootEl) {
        return new IntersectionObserver(observerCallback, {
            ...observerOptions,
            root: rootEl,
        });
    }
};

export { getObserver };
//# sourceMappingURL=getObserver.js.map
